const VIDEO_RE = /\.(webm|mp4|mov|avi|ogv)(\?|$)/i;
const MIME = { webm: 'video/webm', mp4: 'video/mp4', mov: 'video/quicktime', avi: 'video/x-msvideo', ogv: 'video/ogg' };

export default function Picture({ url, alt, lazy }) {
  const match = url.match(VIDEO_RE);

  return match ? (
    <video
      key={url}
      autoPlay
      loop
      muted
      playsInline
      className="object-cover w-full h-full"
      loading={lazy ? "lazy" : undefined}
    >
      <source src={url} type={MIME[match[1].toLowerCase()] || 'video/mp4'} />
    </video>
  ) : (
    <img
      key={url}
      loading={lazy ? "lazy" : undefined}
      src={url}
      alt={alt}
      className="object-cover w-full h-full"
    />
  );
}
